/**
 * 团队任务二=>团队任务 teamrefine =》 team api
 */
import { http, https } from '../../global/axios';

/**
 *  领取任务
 */
export const getTask = (params) => {
  return https.get(`v2/tags/task/pull/module/${params.id}.json`);
};
/**
 *  判断是否显示保底计划
 */
export const valGuarantee = (params) => {
  return https.post(`v2/tags/guarantee/team/validate.json`, params);
};
/**
 *  提交保底计划
 */
export const subGuarantee = (params) => {
  return https.post(`v2/tags/guarantee/team/acquire.json`, params);
};
/**
 *  申请团队状态
 */
export const joinStatus = () => {
  return http.post(`v1/team/offline/status.json`);
};
/**
 *  申请团队
 */
export const joinApply = (params) => {
  return http.post(`v1/team/offline/apply.json`, params);
};
/**
 *  审核团队（新审核）
 */
export const newCheck = (params) => {
  return http.post(`v2/tags/lib/module/check/detail.json`, params);
};

/**
 * 审核批量操作
 */
export const newCheckOperation = (data) => {
  return http.post(`v2/tags/lib/modules/check/batch/annotation.json`, data);
}
